<script setup lang="ts">
import { useAppStore } from '@/stores/app'
import getMpcUrlByCountry from '@/shared/utils/get-mpc-url-by-country'
import SvgIcon from '@/components/common/SvgIcon.vue'
import { ESprites, ESpritesUI } from '@/shared/enum/sprites.enum'
import useAnalytics from '@/shared/composables/useAnalytics'

const { sendCtaClickToAnalytics } = useAnalytics()

const redirectToMiPagoClaro = () => {
  const appStore = useAppStore()
  const destinationUrl = getMpcUrlByCountry(appStore.country)!

  sendCtaClickToAnalytics({
    cta_name: 'paid_invoices',
    source_url: window.location.href,
    destination_url: destinationUrl,
    country: appStore.country
  })

  window.location.href = destinationUrl
}
</script>

<template>
  <a
    id="landing-invoice"
    data-testid="qa_landing_invoice"
    class="flex flex-col items-center justify-center gap-2 align-middle border rounded-lg shadow-md cursor-pointer landing__button"
    itemprop="potentialAction"
    itemscope
    itemtype="http://schema.org/Action"
    @click="redirectToMiPagoClaro"
  >
    <span class="self-center text-sm font-bold text-center sm:text-base" itemprop="name">
      Pagar mis Facturas
    </span>
    <div class="justify-self-center">
      <SvgIcon :file="ESprites.UI" :name="ESpritesUI.INVOICES" width="48" height="48" />
    </div>
  </a>
</template>

<style scoped></style>
